import queryString from 'qs';
import moment from 'moment';

const getPresenceHistoryRequest = (queryParams) => {
  const queries = { limit: queryParams?.limit, page: queryParams?.page };

  if (queryParams?.startDate) queries.startedAt = moment(queryParams.startDate).format('YYYY-MM-DD');
  if (queryParams?.endDate) queries.endedAt = moment(queryParams.endDate).format('YYYY-MM-DD');

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getPresenceHistoryRequest;
